var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToitmaison(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "toit_maison",
    "data-name": "toit maison",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 178.262 68.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_264",
    "data-name": "Trac\\xE9 264",
    d: "M175.632,56.816,104.341,4.657a27.173,27.173,0,0,0-30.422,0L2.627,56.816C-2.905,60.87.893,67.983,8.58,67.983h4.337S61.461,30.932,77.874,18.849c8.042-5.963,12.747-5.416,19.791-.156,16.742,12.507,67.678,49.346,67.678,49.346h4.323C177.406,67.949,181.165,60.87,175.632,56.816Z",
    transform: "translate(-0.003 0)",
    fill: "#2c3852"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_265",
    "data-name": "Trac\\xE9 265",
    d: "M35.75,14.152V5.71A3.75,3.75,0,0,0,32,2H19.2a3.75,3.75,0,0,0-3.75,3.76V28.723Z",
    transform: "translate(5.997 11.019)",
    fill: "#2c3852"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToitmaison);
export default __webpack_public_path__ + "static/media/toitmaison.218f095d.svg";
export { ForwardRef as ReactComponent };